import * as BECaller from '../../util/apiCaller';
import { getInfo } from '../Auth/AuthActions';
import { setError, setSuccessMessage } from '../App/ErrorsActions';

export const ADDONS = 'ADDON_PLANS_DATA',
  ADDON_REQ_SENT = 'ADDON_REQUEST_SENT',
  ADDON_REQ_FAILED = 'ADDON_REQUEST_FAILED',
  ADDON_ESTIMATE = 'ADDON_ESTIMATE',
  ADDON_UPDATE_STEP = 'ADDON_UPDATE_STEP',
  ADDON_LOADING = 'ADDON_PAYMENT_LOADING';

function success(data) {
  return {
    type: ADDONS,
    addons: data,
  };
}

function failedActivation(err) {
  return {
    type: ADDON_REQ_FAILED,
    error: err,
  };
}

function successActivation() {
  return {
    type: ADDON_REQ_SENT,
  };
}

export function setLoading(value) {
  return { type: ADDON_LOADING, value };
}

export function error(err, opt) {
  return setError(err, opt);
}

export function clearEstimation() {
  return { type: ADDON_ESTIMATE, data: {} };
}

export function updateStepData(model) {
  return {
    type: ADDON_UPDATE_STEP,
    model,
  };
}

export function getDigitalPlans() {
  return (dispatch, getState) => {
    const { addons } = getState().digital;
    if (addons.annual) {
      return true;
    }

    BECaller.api(`billing/digital`, 'get').then(
      (data) => {
        dispatch(success(data));
      },
      (err) => {
        dispatch(setError(err));
      }
    );
  };
}

export function saveBillingInfo(model) {
  return (dispatch) => {
    return BECaller.api(`billing/customer`, 'put', model).then(
      (data) => {
        return Promise.resolve();
      },
      (err) => {
        dispatch(setError(err));
        return Promise.reject();
      }
    );
  };
}

export function requestActivation(model) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return BECaller.api(`billing/request`, 'post', model).then(
      (data) => {
        dispatch(setSuccessMessage('Your subscription has been activated successfully'));
        dispatch(successActivation());
        return dispatch(getInfo());
      },
      (err) => {
        if (err.data && err.data.payment) {
          dispatch(setError(err.data.payment.error.message));
        } else {
          dispatch(setError("We weren't able to process your payment. Please try again or use a different card."));
        }
        dispatch(failedActivation(err));
      }
    );
  };
}

export function requestUpgrade(model) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return BECaller.api(`billing/upgradeAddon`, 'post', model).then(
      (data) => {
        dispatch(setSuccessMessage('Your plan has been changed successfully'));
        dispatch(successActivation());
        return dispatch(getInfo());
      },
      (err) => {
        if (err.data && err.data.payment) {
          dispatch(setError(err.data.payment.error.message));
        } else {
          dispatch(setError("We weren't able to process your payment. Please try again or use a different card."));
        }
        dispatch(failedActivation(err));
      }
    );
  };
}

export function estimate(model) {
  return (dispatch) => {
    return BECaller.api(`billing/estimateAddon`, 'post', model).then(
      (data) => {
        if (data.discounts && data.discounts.length > 0) {
          dispatch(setSuccessMessage('Coupon applied successfully'));
        }
        dispatch({ type: ADDON_ESTIMATE, data });
        dispatch(updateStepData(model));

        return Promise.resolve(data);
      },
      (err) => {
        dispatch(setError(err));
        return Promise.reject(err);
      }
    );
  };
}
